export const getRedirectLocation = () => {
  const loggedInRedirectMap = {
    1: JSON.parse(localStorage.getItem("mobile-view")) ? "/dashboard" : "/graphsDashboard",
    2: "/integrations",
    3: "/graphsDashboard",
    // 4: "/ffDashboard",
    4: "/pmDashboard",
    5: "/addPackage", //TODO: It should be changed to package upload screen.
    7: `/cutting/all?size=&piece_no=&piece_length=&description=&spool_id=&order=&column`,
    6: "/board?state=fabrication",
    12: "/board?state=fabrication",
    13: "/mtrManagment",
    14: "/weldInspectionDashBoard",
  };
  const redirectLocation =
    loggedInRedirectMap[JSON.parse(localStorage.getItem("roleId"))] || "/not-found?logout=1";
  return redirectLocation;
};
